import { debug }   from './theme/debug.js';
import { helpers } from './theme/helpers.js';

import { viewport }         from './theme/components/viewport.js';
import { navigation }       from './theme/components/navigation.js';
import { stickyHeader }     from './theme/components/sticky-header.js';
import { mobileNavigation } from './theme/components/mobile-navigation.js';
import { columns }          from './theme/components/columns.js';
import { carousel }         from './theme/components/carousel.js';
import { map }              from './theme/components/map.js';
import { spinner }          from './theme/components/spinner.js';
import { form }             from './theme/components/form.js';
import { modal }            from './theme/components/modal.js';
import { posts }            from './theme/components/posts.js';
import { testimonials }     from './theme/components/testimonials.js';
import { gallery }         from './theme/components/gallery.js';

window.theme = {
    globals: {
        enablePjax: true,
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },
    init: function() {
        var theme = this;

        //Global
        theme.smoothScroll.init();
        
        viewport.init();
        navigation.init();
        stickyHeader.init();
        mobileNavigation.init();
        columns.init();
        carousel.init();
        map.init();
        spinner.init();
        form.init();
        modal.init();
        testimonials.init();
        posts.init();
        gallery.init();

        $( document.body ).addClass( 'loaded' );

        if ( theme.globals.isTouch === true ) {
            $( document.body ).addClass( 'touch-device' );
        } else {
            $( document.body ).addClass( 'pointer-device' );
        }

        document.addEventListener( 'wpcf7mailsent', function( event ) {            
            window.dataLayer.push( {
                'event' : 'form_sent'
            } );
        } ); 
    },
    smoothScroll: {
        selector: 'a[data-anchor]',
        init: function() {
            var self = this,
            scroll = new SmoothScroll( self.selector, {
                ignore: '[data-scroll-ignore]',
                topOnEmptyHash: false,
                speed: 1000,
                offset: 140,
                updateURL: false,
                easing: 'easeInOutCubic',
            } );
        }
    },
}

jQuery( document ).ready( function( $ ) {
    theme.init();
} );
